import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { LicenseQueryKey } from './queryKey';
export const useActivateLicense = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation(({ billingPeriod, promoCode }) => api.base
        .get(`/api/license/activate/${billingPeriod}/${promoCode}`)
        .then(res => res.data), {
        onSuccess: (result) => {
            if (!result)
                return;
            queryClient.setQueryData([LicenseQueryKey.Info], result);
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { activateLicense: mutateAsync, isActivating: isLoading };
};
export default useActivateLicense;
